export const colorArray = [
  '#151515',
  '#2d163a',
  '#1c1446',
  '#2f242c',
  '#685762',
]
